// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
  "data": {
    "id": 1,
    "attributes": {
      "heading": "Order History",
      "createdAt": "2025-06-06T06:45:33.972Z",
      "updatedAt": "2025-06-06T06:47:30.780Z",
      "publishedAt": "2025-06-06T06:45:35.359Z",
      "locale": "en",
      "download_app_banner": {
        "id": 1,
        "text": "Unlock Your Full Order History on the Porter App!",
        "sub_text": null,
        "cta": {
          "id": 4,
          "label": "Download Now",
          "href": "https://porter.in/app"
        },
        "image": {
          "id": 14,
          "alt_text": "download app",
          "src_path": {
            "data": {
              "id": 11,
              "attributes": {
                "name": "bg-promo-image.png",
                "alternativeText": null,
                "caption": null,
                "width": 1080,
                "height": 1155,
                "formats": {
                  "large": {
                    "ext": ".png",
                    "url": "/uploads/large_bg_promo_image_e267444e6a.png",
                    "hash": "large_bg_promo_image_e267444e6a",
                    "mime": "image/png",
                    "name": "large_bg-promo-image.png",
                    "path": null,
                    "size": 371.79,
                    "width": 935,
                    "height": 1000
                  },
                  "small": {
                    "ext": ".png",
                    "url": "/uploads/small_bg_promo_image_e267444e6a.png",
                    "hash": "small_bg_promo_image_e267444e6a",
                    "mime": "image/png",
                    "name": "small_bg-promo-image.png",
                    "path": null,
                    "size": 87.08,
                    "width": 468,
                    "height": 500
                  },
                  "medium": {
                    "ext": ".png",
                    "url": "/uploads/medium_bg_promo_image_e267444e6a.png",
                    "hash": "medium_bg_promo_image_e267444e6a",
                    "mime": "image/png",
                    "name": "medium_bg-promo-image.png",
                    "path": null,
                    "size": 202.69,
                    "width": 701,
                    "height": 750
                  },
                  "thumbnail": {
                    "ext": ".png",
                    "url": "/uploads/thumbnail_bg_promo_image_e267444e6a.png",
                    "hash": "thumbnail_bg_promo_image_e267444e6a",
                    "mime": "image/png",
                    "name": "thumbnail_bg-promo-image.png",
                    "path": null,
                    "size": 11.15,
                    "width": 146,
                    "height": 156
                  }
                },
                "hash": "bg_promo_image_e267444e6a",
                "ext": ".png",
                "mime": "image/png",
                "size": 99.25,
                "url": "/uploads/bg_promo_image_e267444e6a.png",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "createdAt": "2025-02-28T08:34:00.142Z",
                "updatedAt": "2025-03-04T07:42:46.071Z"
              }
            }
          }
        }
      },
      "localizations": {
        "data": [
          {
            "id": 2,
            "attributes": {
              "heading": "Order History",
              "createdAt": "2025-06-06T06:47:30.721Z",
              "updatedAt": "2025-06-06T06:47:50.509Z",
              "publishedAt": "2025-06-06T06:47:31.655Z",
              "locale": "en-IN"
            }
          }
        ]
      }
    }
  },
  "meta": {

  }
};

export {
  dummyResponse ,
}
/* No side effect */
